<template>
    <section>
        <loader :loading="loading"></loader>
        <div v-if="order.countdown == null">
            <div v-if="!listOrderWindow">
                <p>{{ $t("orders.orderWindow.unlinkedOrderMessage") }}.</p>
                <button class="btn btn-client selectOrderButton" v-if="diamAdminRights" @click="showOrderWindowList();">
                    {{ $t("orders.orderWindow.selectButton") }}
                </button>
            </div>

            <div class="orderWindowListBloc" v-if="diamAdminRights && listOrderWindow">
                {{ $t("orders.orderWindow.listeTitle") }} :
                <div class="orderWindowsList">
                    <div
                        class="orderWindowItem"
                        @click="selectOrderWindow(orderWindow);"
                        v-for="(orderWindow, index) in getCountDownNext"
                        :key="orderWindow.id"
                        :class="{ dashed: index % 2 == 0, active: orderWindow.id == orderWindowSelected.countdown.id }"
                    >
                        <h4 class="orderWindowItemTitle">{{ orderWindow.name }}</h4>
                        <p>{{ formatDate(orderWindow.startDate) }} >>>> {{ formatDate(orderWindow.endDate) }}</p>
                    </div>
                    <button class="btn btn-client fright" v-if="diamAdminRights && getCountDownNext.length > 0" @click="linkOrderWindowAction();">
                        {{ $t("orders.orderWindow.linkAction") }}
                    </button>
                </div>
            </div>
        </div>
        <div v-else>
            {{ $t("orders.orderWindow.linkedTitle") }} :
            <h4 class="orderWindowTitle">
                <span class="roundedIcon"><i class="far fa-calendar-alt fa-lg"></i></span> {{ order.countdown.name }}
            </h4>
            <button class="btn btn-client" v-if="diamAdminRights" @click="unlinkOrderWindowAction();">
                {{ $t("orders.orderWindow.unlinkAction") }}
            </button>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loader from "../../loader/loader";

export default {
    name: "order-windows",
    data() {
        return {
            hasOrderWindow: false,
            listOrderWindow: false,
            orderWindowSelected: {
                countdown: {
                    id: null
                }
            },
            loading: false
        };
    },
    components: { loader },
    computed: {
        diamAdminRights() {
            return this.hasDiamAccess("orders_manager", ...this.AccessUser.CONTRIBUTE);
        },
        ...mapGetters("countdown", {
            getCountDownNext: "getCountDownNext"
        }),
        ...mapGetters("order", {
            order: "details/getOrder"
        })
    },
    methods: {
        ...mapActions("countdown", {
            listCountDown: "listCountDown"
        }),
        ...mapActions("order", {
            linkOrderWindow: "details/linkOrderWindow"
        }),

        showOrderWindowList() {
            this.listOrderWindow = true;
        },
        selectOrderWindow(orderWindow) {
            this.orderWindowSelected.countdown.id = orderWindow.id;
        },
        async linkOrderWindowAction() {
            if (this.orderWindowSelected.countdown.id == null) {
                this.dialogError(this.$t("orders.orderWindow.linkError"));
                return false;
            }
            try {
                this.loading = true;
                const res = await this.linkOrderWindow(this.orderWindowSelected);
                this.listOrderWindow = false;
                this.dialogSuccess(this.$t("orders.orderWindow.linkSuccess").replace("{name}", res.countdown.name));
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        },
        async unlinkOrderWindowAction() {
            if (this.order.countdown == null) {
                this.dialogError(this.$t("orders.orderWindow.un linkError"));
                return false;
            }
            try {
                this.loading = true;
                await this.linkOrderWindow({ countdown: { id: null } });
                this.dialogSuccess(this.$t("orders.orderWindow.unlinkSuccess"));
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        }
    },
    created() {
        this.listCountDown();
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

.selectOrderButton {
    margin: 15px 0px;
}

.orderWindowsList {
    max-height: 300px;
    overflow-y: auto;
    cursor: pointer;
    .orderWindowItem {
        @extend %primary-text;
        @extend %second-background;
        padding: 2px;
        margin: 10px 0px;
        .orderWindowItemTitle {
            color: $color4;
            margin: 3px 0px;
            text-transform: uppercase;
            font-size: 14px;
        }
        p {
            margin: 0px 0px;
            font-size: 13px;
        }
        &.dashed {
            @extend %primary-background;
        }
        opacity: 0.5;
        -webkit-transition: all 0.2s linear;
        -mos-transition: all 0.2s linear;
        -o-transition: all 0.2s linear;
        transition: all 0.2s linear;
        &:hover,
        &.active {
            opacity: 1;
        }
    }
}
.roundedIcon {
    background-color: $color4;
}
.orderWindowTitle {
    color: $color4;
}
</style>



// WEBPACK FOOTER //
// order-windows.vue?5795bbe4